import { CoreStore } from "Stores/RESTStore/CoreStore";
import { observable, action, runInAction, makeObservable } from "mobx";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { API } from "General/API";
// import { mockMetadata } from './mockMetadata.js';

export class MetadataStore extends CoreStore {
  data: API_Metadata[] = [];

  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      clear: action,
      fetch: action.bound,
    });
  }

  url() {
    return API_URL.METADATA.getDefinitions(projectsDataStore.projectId);
  }

  clear() {
    this.data = [];
  }

  async fetch() {
    try {
      const response: API_Metadata[] = await API.getData(this.url());
      runInAction(() => {
        this.data = response;
        // this.data = mockMetadata;
      });
    } catch (error) {
      throw error;
    }
  }
}

export const metadataStore = new MetadataStore();
